'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

var _immutable = require('immutable');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id) {
  return function (dispatch, getState) {
    var participants = (0, _paths.getParticipantsOfAnEvent)(getState(), event_id) || (0, _immutable.List)();

    if (participants.size > 0) {
      return Promise.resolve();
    }

    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisEventsPrefix)(feis_id) + '/' + event_id + '/participants'
      },
      types: ['GET_PARTICIPANTS_START', 'GET_PARTICIPANTS', 'GET_PARTICIPANTS_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/getParticipants.js
// module id = 104
// module chunks = 0